import '../css/marketing.css';

import { createIcons, Layout, Kanban, Lock, Users } from 'lucide';

createIcons({
    icons: {
        Layout,
        Kanban,
        Lock,
        Users,
    },
});
